import { get } from 'axios'

import {
  call,
  takeEvery,
  put,
} from 'redux-saga/effects'

import { baseURL } from 'config'
import {
  FETCH_EMPLOYEE_LIST,
} from './constants'
import {
  startFetchEmployeeListAsync,
  resetEmployeeList,
  updateEmployeeList,
  fetchEmployeeListSuccess,
  fetchEmployeeListStart,
  fetchEmployeeListError,
} from './actions'

const url = `${baseURL}/api/cftt_external/SecurityEntities`
const buildUrl = (query, count = 5) => {
  const suffix = 'getUsers=true&getGroups=false'
  return `${url}?prefixText=${query}&count=${count}&${suffix}`
}

function* fetchEmployeeList(query) {
  try {
    yield put(startFetchEmployeeListAsync())
    yield put(fetchEmployeeListStart())
    const getUrl = buildUrl(query)
    const { data } = yield call(get, getUrl)
    const json = JSON.parse(data)
    const employees = json
      .filter(({ Active }) => Active === true)
      .reduce((result, { DisplayName: name, sAMAccountName: username }) => {
        result[username] = { name, username }
        return result
      }, {})

    yield put(fetchEmployeeListSuccess(employees))
    return employees
  } catch(error) {
    yield put(fetchEmployeeListError(error))
  }
}

function* fetchEmployeeHandler(action) {
  const { value } = action
  if( value && value.length > 2) {
    const employees = yield call(fetchEmployeeList, value)
    yield put(updateEmployeeList(employees))
  } else {
    yield put(fetchEmployeeListSuccess({}))
  }
}

function* watchGetEmployeeList() {
  yield takeEvery(FETCH_EMPLOYEE_LIST, fetchEmployeeHandler)
}

export default watchGetEmployeeList
